import { auth, usersRef } from "@/firebase.js"
import router from '../router'

export default {
  state: {
    session: null,
    userData: null,
    user: null,
    token: null,
    msGraph: null,
    loginError: false
  },
  mutations: {
    async setUser (state, user) {
      state.user = user;
    },
    async setLoginError (state, error) {
      state.loginError = error;
    },
    async setUserData (state, userData) {
      state.userData = userData;
    }
  },
  actions: {
    async login ({ commit }, {email, password}) {
      await commit('setLoginError', false);
      await auth.signInWithEmailAndPassword(email, password)
        .then(
          async authUser => {
            commit('setUser', authUser)
            router.push('/appointments')
          }
        )
        .catch(
          error => {
            commit('setLoginError', true)
          }
        );
    },
    async loadUserData({ commit }, email) {
      let user = await usersRef.where("Email", "==", email).get();
      await commit('setUserData', user.docs[0].data())
    },
    async autoSignIn ({ commit, dispatch }, user) {
      commit('setUser', user)
      if (router.history.current.name == 'signin') {
        router.push(`/appointments`)
      }
      return dispatch('loadUserData', user.email);
    },
    async setUser ({ commit }, user) {
      commit("setUser", user)
    },
    logout ({ commit }) {
      commit("setUser", null)
      router.push('/login')
      auth.signOut()
    }
  },
  getters: {
    user (state) {
      return state.user;
    },
    loginError (state) {
      return state.loginError;
    },
    userData (state) {
      return state.userData;
    }
  }
};
